(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-announcement')) {
    customElements.define(
      'campaign-announcement',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.status = this.querySelector('[data-status]');
          this.countdowns = Array.from(this.querySelectorAll('[data-countdown]'));
          this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
          this.interval = Math.max(Number(this.dataset.interval) || 5000, 2500);
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.onVisibilityChange = () => (document.hidden ? this.stop() : this.start());
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          document.addEventListener('visibilitychange', this.onVisibilityChange);
          this.updateCountdowns();
          if (this.countdowns.length) {
            this.countdownTimer = window.setInterval(() => this.updateCountdowns(), 1000);
          }
          this.start();
        }

        disconnectedCallback() {
          this.stop();
          window.clearInterval(this.countdownTimer);
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
        }

        updateCountdowns() {
          const now = Date.now();

          this.countdowns.forEach((countdown) => {
            const endTime = Date.parse(countdown.dataset.end || '');
            if (!Number.isFinite(endTime)) {
              countdown.hidden = true;
              countdown.closest('.halloween-announcement-bar__inner')?.classList.remove('halloween-announcement-bar__inner--countdown');
              return;
            }

            const totalSeconds = Math.max(0, Math.floor((endTime - now) / 1000));
            const days = Math.floor(totalSeconds / 86400);
            const hours = Math.floor((totalSeconds % 86400) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            const pad = (value) => String(value).padStart(2, '0');

            countdown.querySelector('[data-countdown-days]').textContent = pad(days);
            countdown.querySelector('[data-countdown-hours]').textContent = pad(hours);
            countdown.querySelector('[data-countdown-minutes]').textContent = pad(minutes);
            countdown.querySelector('[data-countdown-seconds]').textContent = pad(seconds);
            countdown.setAttribute('aria-label', `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`);
          });
        }

        start() {
          this.stop();
          if (this.slides.length < 2 || this.reducedMotion || document.hidden) return;
          this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.interval);
        }

        stop() {
          window.clearInterval(this.timer);
        }

        show(index) {
          const previous = this.slides[this.currentIndex];
          this.currentIndex = index % this.slides.length;
          const next = this.slides[this.currentIndex];

          previous.classList.remove('is-active');
          previous.classList.add('is-leaving');
          previous.setAttribute('aria-hidden', 'true');
          previous.setAttribute('inert', '');
          next.classList.remove('is-leaving');
          next.classList.add('is-active');
          next.setAttribute('aria-hidden', 'false');
          next.removeAttribute('inert');

          window.setTimeout(() => previous.classList.remove('is-leaving'), 520);
          if (this.status) this.status.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiks-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-kiks-image-text-carousel]';
    const minimumViewport = 375;
    const maximumViewport = 749;
    const minimumPerView = 1.4;
    const minimumCardWidth = 220;
    const targetCardWidth = 240;
    const gap = 8;

    const setActiveDot = (carousel, activeIndex) => {
      const dots = Array.from(carousel.querySelectorAll('[data-kiks-image-text-dot]'));
      if (dots.length === 0) return;

      let closestDot = dots[0];
      let closestDistance = Infinity;

      dots.forEach((dot) => {
        const distance = Math.abs(Number(dot.dataset.carouselIndex) - activeIndex);
        if (distance < closestDistance) {
          closestDot = dot;
          closestDistance = distance;
        }
      });

      dots.forEach((dot) => {
        dot.setAttribute('aria-current', dot === closestDot ? 'true' : 'false');
      });
    };

    const renderPagination = (carousel) => {
      const pagination = carousel.querySelector('[data-kiks-image-text-pagination]');
      if (!pagination) return;

      const slideCount = carousel.querySelectorAll('xo-carousel-slide:not([xo-cloned])').length;
      const perView = Number(carousel.getAttribute('xo-per-view')) || minimumPerView;
      const maximumIndex = Math.max(0, slideCount - perView);
      const dotCount = maximumIndex > 0 ? Math.ceil(maximumIndex) + 1 : 0;
      const pageLabel = pagination.dataset.pageLabel || 'Page [page]';

      pagination.replaceChildren();

      for (let index = 0; index < dotCount; index += 1) {
        const dot = document.createElement('button');
        const carouselIndex = Math.min(index, maximumIndex);
        dot.type = 'button';
        dot.className = 'kiks-image-text__paginate-dot';
        dot.dataset.kiksImageTextDot = '';
        dot.dataset.carouselIndex = carouselIndex;
        dot.setAttribute('aria-label', pageLabel.replace('[page]', String(index + 1)));
        dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        pagination.appendChild(dot);
      }
    };

    const bindPagination = (carousel) => {
      if (carousel.dataset.kiksPaginationBound === 'true') return;

      carousel.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-kiks-image-text-dot]');
        if (!dot || !window.xoCarousel) return;
        window.xoCarousel.goTo(carousel.xoName, Number(dot.dataset.carouselIndex));
      });

      carousel.addEventListener('change', (event) => {
        setActiveDot(carousel, Number(event.detail?.activeIndex) || 0);
      });

      carousel.dataset.kiksPaginationBound = 'true';
    };

    const updateCarousel = (carousel) => {
      if (carousel.offsetParent === null || carousel.clientWidth === 0) return;

      bindPagination(carousel);

      const viewport = Math.min(maximumViewport, Math.max(minimumViewport, window.innerWidth));
      const progress = (viewport - minimumViewport) / (maximumViewport - minimumViewport);
      const cardWidth = minimumCardWidth + (targetCardWidth - minimumCardWidth) * progress;
      const perView = (carousel.clientWidth + gap) / (cardWidth + gap);
      const value = Math.max(minimumPerView, perView).toFixed(3);

      if (carousel.getAttribute('xo-per-view') !== value) {
        carousel.setAttribute('xo-per-view', value);
        carousel.setAttribute('xo-observed', value);
      }

      renderPagination(carousel);
    };

    const updateAll = (root = document) => {
      root.querySelectorAll(selector).forEach(updateCarousel);
    };

    let resizeFrame;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(() => updateAll());
    });

    document.addEventListener('shopify:section:load', (event) => updateAll(event.target));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => updateAll());
    } else {
      updateAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var desktopMediaQuery = window.matchMedia('(min-width: 992px)');

    function initMainProductScrollLayout(root) {
      root.querySelectorAll('.main-product__container--scroll-content').forEach(function(container) {
        if (container.dataset.scrollLayoutInit) return;

        var imageContent = container.querySelector('.main-product__image-content');
        var productContent = container.querySelector('.main-product__content');
        if (!imageContent || !productContent) return;

        container.dataset.scrollLayoutInit = 'true';

        function syncContainerHeight() {
          if (!desktopMediaQuery.matches) {
            container.style.removeProperty('--main-product-image-content-height');
            return;
          }

          var imageHeight = imageContent.getBoundingClientRect().height;
          if (imageHeight > 0) {
            container.style.setProperty('--main-product-image-content-height', imageHeight + 'px');
          }
        }

        var imageResizeObserver = new ResizeObserver(syncContainerHeight);
        imageResizeObserver.observe(imageContent);
        container.mainProductResizeObserver = imageResizeObserver;
        desktopMediaQuery.addEventListener('change', syncContainerHeight);

        productContent.addEventListener('wheel', function(event) {
          if (!desktopMediaQuery.matches || event.deltaY === 0 || event.ctrlKey) return;

          var atTop = productContent.scrollTop <= 0;
          var atBottom = Math.ceil(productContent.scrollTop + productContent.clientHeight) >= productContent.scrollHeight;
          var shouldScrollPage = event.deltaY < 0 ? atTop : atBottom;

          if (!shouldScrollPage) return;

          var scrollDistance = event.deltaY;
          if (event.deltaMode === 1) scrollDistance *= 16;
          if (event.deltaMode === 2) scrollDistance *= window.innerHeight;

          event.preventDefault();
          event.stopPropagation();
          window.scrollBy(0, scrollDistance);
        }, { passive: false, capture: true });

        syncContainerHeight();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initMainProductScrollLayout(document);
      });
    } else {
      initMainProductScrollLayout(document);
    }
    document.addEventListener('shopify:section:load', function(event) {
      initMainProductScrollLayout(event.target);
    });
  })();

 
  (function(){
    function initReadMore(root=document){
      root.querySelectorAll('.usp-richtext:not(.usp-richtext--no-readmore)').forEach(function(el){
        if (el.dataset.readmoreInit) return; // prevent double init
        el.dataset.readmoreInit = "1";
  
        // Compute line height robustly
        var cs = getComputedStyle(el);
        var lh = parseFloat(cs.lineHeight);
        if (isNaN(lh)) {
          // 'normal' → approximate from font-size
          lh = parseFloat(cs.fontSize) * 1.4;
        }
        var maxLines = 4;
  
        // Ensure the clamp is applied before measuring
        el.style.setProperty('--lines', maxLines);
  
        // Measure after layout
        requestAnimationFrame(function(){
          var isOverflowing = el.scrollHeight > (lh * maxLines + 1);
          if (!isOverflowing) return;
  
          // Add button after the element
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'usp-readmore';
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = 'Read more';
          el.insertAdjacentElement('afterend', btn);
  
          btn.addEventListener('click', function(){
            var expanded = el.getAttribute('data-expanded') === 'true';
            el.setAttribute('data-expanded', expanded ? 'false' : 'true');
            btn.setAttribute('aria-expanded', (!expanded).toString());
            btn.textContent = expanded ? 'Read more' : 'Read less';
          });
        });
      });
    }
  
    // Init on normal load
    document.addEventListener('DOMContentLoaded', function(){ initReadMore(); });
  
    // Re-init when fonts finish (affects measurements)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function(){ initReadMore(); });
    }
  
    // Init when Shopify editor re-renders sections
    document.addEventListener('shopify:section:load', function(e){ initReadMore(e.target); });
    document.addEventListener('shopify:section:reorder', function(e){ initReadMore(e.target); });
  })();

  
// Simple Video Popup Modal
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('video-popup-modal');
    if (!modal) return;

    const modalPlayer = document.getElementById('video-popup-modal__player');
    const closeModalBtn = document.getElementById('video-popup-modal__close');
    
    // Store the original video content
    const originalVideoContent = modalPlayer.innerHTML;
    
    function openModal() {
        // Restore the video content if it was cleared
        if (modalPlayer.innerHTML === '') {
            modalPlayer.innerHTML = originalVideoContent;
        }
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        
        // Auto-play the video when modal opens
        const video = modalPlayer.querySelector('video');
        if (video) {
            video.play().catch(function(error) {
                // Handle autoplay policy restrictions
                console.log('Autoplay prevented:', error);
            });
        }
    }

    function closeModal() {
        // Pause any playing video before closing
        const video = modalPlayer.querySelector('video');
        if (video && !video.paused) {
            video.pause();
        }
        
        modal.style.display = 'none';
        // Don't clear the content, just hide the modal
        document.body.style.overflow = '';
    }

    // Open modal on button click
    document.body.addEventListener('click', function(e) {
        const trigger = e.target.closest('.js-video-popup-trigger');
        if (trigger) {
            e.preventDefault();
            openModal();
        }
    });
    
    // Close modal on close button click
    closeModalBtn.addEventListener('click', closeModal);
    
    // Close modal on backdrop click
    modal.addEventListener('click', function(e) {
        if (e.target === modal) closeModal();
    });

    // Close modal on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.style.display === 'flex') {
            closeModal();
        }
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.socialVideoReady === 'true') return;
      root.dataset.socialVideoReady = 'true';

      const track = root.querySelector('[data-carousel-track]');
      const previous = root.querySelector('[data-carousel-previous]');
      const next = root.querySelector('[data-carousel-next]');
      const updateControls = () => {
        if (!track) return;
        const end = track.scrollWidth - track.clientWidth;
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= end - 2;
      };

      previous?.addEventListener('click', () => {
        track?.scrollBy({ left: -(track.clientWidth * 0.8), behavior: 'smooth' });
      });
      next?.addEventListener('click', () => {
        track?.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });
      track?.addEventListener('scroll', updateControls, { passive: true });
      updateControls();

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-video-play]');
        if (!button || !root.contains(button)) return;

        const media = button.closest('[data-video-media]');
        const template = media?.querySelector('[data-video-template]');
        if (!template) return;

        root.querySelectorAll('video').forEach((video) => video.pause());
        media.classList.add('is-playing');
        media.querySelector('.social-video-carousel__poster')?.remove();
        media.append(template.content.cloneNode(true));
        template.remove();
        button.remove();
      });
    };

    document.querySelectorAll('[data-social-video-carousel]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-social-video-carousel]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
